












import Vue from 'vue';
import util from '@/components/util';

export default Vue.extend({
  name: 'ModalFormDataCheck',
  components: { ...util},
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickConfirmation() {
      this.$emit('onClickConfirmation');
    },
  },
});
